import { createFileRoute } from '@tanstack/react-router';
import { RoutePlaceholder } from './-components/RoutePlaceholder';

export const Route = createFileRoute('/results')({
  component: () => (
    <RoutePlaceholder
      icon="book"
      title="Results"
      description="Settled results by date and sport."
    />
  ),
});
